import React, {Component} from "react";
import {MDBModal,MDBModalBody, MDBModalHeader} from "mdbreact";
import './style.scss';
import {connect} from "react-redux";
import * as actionCreator from "../../../../../../store/Action";

class ViewAnswers extends Component {
  closeModal = () => {
    this.props.eventModalDataAction([])
    this.props.eventModalAction(false);
  }
  render() {
    let {data, modalVisible} = this.props;
    return (
      <div>
        {modalVisible ? <MDBModal isOpen={true} toggle={()=>{}} size={"md"}>
          <MDBModalHeader className={"title"} toggle={this.closeModal}>
            View Answers
          </MDBModalHeader>
          <MDBModalBody>
            <div className={'ques-body'}>
              <div>
                {data.map((obj,index)=> {
                  return <div key={index} className={'ques-ans-wrapper'}>
                    <p className={`${obj.question.mandatory ? `required-lbl`:``}`}><span>{index < 9 ? `${index + 1}` : index + 1}. </span>{obj.question.question}</p>
                    <div className={'ques-ans'}>
                      {obj.question.answerType === "MULTIPLE" ?
                        <div>
                          {obj.question.answers.map((ans, ans_id) => {
                            return <button className={`${obj.answerDTO.subEventParticipantRegistrationAnswerId === ans.subEventParticipantRegistrationAnswerId ? `check-btn`:``}`} key={ans_id}><div className={'circle'}/>{ans.answer}</button>
                          })}
                        </div>
                        :<input contentEditable={false} value={obj.answer ? obj.answer : ""}/>}
                    </div>
                  </div>
                })}
              </div>
            </div>
          </MDBModalBody>
        </MDBModal>:null}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  modalVisible: state.eventModalReducer.modalVisible,
  data: state.eventModalReducer.modalData
});
const mapDispatchToProps = (dispatch) => {
  return {
    // event modals
    eventModalAction: (data) => dispatch(actionCreator.eventModalAction(data)),
    eventModalDataAction: (data) => dispatch(actionCreator.eventModalDataAction(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ViewAnswers);
// export default ViewAnswers;
